export class LotSos{
    lotNumber:string;
    soNos:number[];
}